import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { contractConstants, contractModels } from '..';

export const useOnlineContractConfigSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: contractModels.IOnlineContractConfig) => {
      const res = await $api.post('/v1/online-contract/config', data);

      return res?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([contractConstants.queryKeys.ONLINE_CONTRACT_CONFIG]);
      }
    }
  );
};
